<template>
<div id="new-account">
  <div class="container">
    <div class="jumbotron">
      <div class="row">
        <div class="col-md-offset-3 col-md-6 text-center">
          <h1>SPIADI</h1>
          <p>
            Surveillance et Prévention des Infections Associées
            aux Dispositifs Invasifs
          </p>
        </div>
      </div>
    </div>
    <user-info
      title= "Ouverture de compte"
      :subtitles= "subtitles"
      :defaultError="error"
      source="account"/>
  </div>
</div>
</template>
<script>
import userinfo from '@/sui/components/userInfo'
export default {
  name: 'new-account',
  data () {
    return {
      subtitles: [
        `Attention ! Ce site est exclusivement réservé au personnel des ES et
des EMS susceptibles de participer à la surveillance SPIADI pour leur.s
établissement.s.`,
        `Pour ouvrir un compte, veuillez saisir vos nom, prénom et adresse
e-mail. Si vous êtes référencé dans l'annuaire dont nous disposons, votre
compte sera automatiquement créé.`,
        `Dans le cas contraire, nous vous demanderons
de nous contacter via le formulaire de contact afin que nous procédions à la
création du compte.`
      ],
      error: `Vérifiez vos nom, prénom, et adresse e-mail
avant de réessayer. Si cette erreur persiste, il est possible que vous ne soyez
pas inscrit dans notre annuaire, auquel cas nous vous prions de bien vouloir
nous contacter en cliquant sur le lien suivant :`
    }
  },
  components: {
    'user-info': userinfo
  }
}
</script>
<style scoped lang="less">
@import '~variables';

#new-account {
    min-height: 100%;
    background-color: @base;

    .jumbotron {
        margin-bottom: 0rem;
    }

    #login-button {
        margin-bottom: 1rem;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
}
</style>
